import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text } from '@as/cotopaxi';
import { FilterContentTypes, } from '@as-react/common-types';
import { FilterSizeItem } from './FilterSizeItem';
import { FILTER_SIZE_SEPARATOR } from '../../../constants/GeneralConstants';
export const FilterSizes = ({ items, type, filter, toggleFilterValue, desktop, search, }) => {
    var _a;
    const isSizeCategoryFilter = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.name.includes(FILTER_SIZE_SEPARATOR);
    const isSizeFilterContentType = filter.filterContentType === FilterContentTypes.SIZE;
    if (isSizeFilterContentType && isSizeCategoryFilter) {
        const filterMap = {};
        items.map(filterItem => {
            const filterName = filterItem.name.split(FILTER_SIZE_SEPARATOR)[1];
            if (filterName && filterMap[filterName]) {
                filterMap[filterName].push(filterItem);
            }
            else if (filterName) {
                filterMap[filterName] = [filterItem];
            }
        });
        const filterEntries = Object.entries(filterMap);
        return (_jsx(_Fragment, { children: filterEntries.map(([filterName, filterValues], index) => (_jsxs(Box, { mobile: { spacing: { paddingBottom: filterEntries.length - 1 === index ? 0 : 1 } }, children: [_jsx(Box, { mobile: { spacing: { paddingBottom: 1 } }, children: _jsx(Text, { emphasized: true, children: filterName }) }), filterValues.map((item) => (_jsx(FilterSizeItem, { item: item, toggleFilterValue: toggleFilterValue, desktop: desktop, filter: filter, type: type, search: search }, item.filterKey)))] }, filterName))) }));
    }
    return (_jsx(_Fragment, { children: items.map((item) => (_jsx(FilterSizeItem, { item: item, toggleFilterValue: toggleFilterValue, desktop: desktop, filter: filter, type: type, search: search }, item.filterKey))) }));
};
